import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import blogdata from '../../data/blogdata.json'
import useFetch from '../../Hooks/useFetch'

function PopularPost(props) {
  const { data } = useFetch()

  const myField = data?.items.find((item, index) => {
    if (item.sys.id === '6wNGEZqxMAnSTFwrHuWbc9') {
      return item
    }
  })

  // console.log(myField?.fields)

  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'
  let datas = props.posts
  // console.log(data)

  return (
    <div>
      <div className='popular-post-area'>
        <div className='container'>
          <div className='post-and-search'>
            <div className='news-search-btn'>
              <i className='fa fa-search' />
            </div>
            <form className='news-search-box'>
              <input type='text' placeholder='Search' />
              <button>
                <i className='fa fa-search' />
              </button>
            </form>
            <h6 className='mb-3 popular-post-title'>Popular Blogs</h6>
            <div className='popular-post-slider'>
              {myField?.fields.blogs.map((item, i) => (
                <div key={i} className='item'>
                  <Link to={item.url} className='media single-popular-post'>
                    <div className='media-left'>
                      <img
                        src={item.image}
                        style={{ height: '61px', width: '62px' }}
                        alt={imagealt}
                      />
                    </div>
                    <div className='media-body'>
                      <h6>{item.title}</h6>
                      <span>{item.date}</span>
                    </div>
                  </Link>
                </div>
              ))}
              {myField?.fields.blogs.map((item, i) => (
                <div key={i} className='item'>
                  <Link to={item.url} className='media single-popular-post'>
                    <div className='media-left'>
                      <img
                        src={item.image}
                        style={{ height: '61px', width: '62px' }}
                        alt={imagealt}
                      />
                    </div>
                    <div className='media-body'>
                      <h6>{item.title}</h6>
                      <span>{item.date}</span>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopularPost
